import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
    SettingOption,
} from '@appblocks/codegeneration/types';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import * as tios from './tios';
import * as simulator from './simulator';
import * as zephyr from './zephyr';

export default class SerialDataNode extends BaseNode {
    constructor() {
        super();
        this.name = 'On Serial Data Received';
        this.id = 'node_ser_data_arrival';
        this.icon = 'VscDebugDisconnect';
        this.requirements = [['tios', 'zephyr']];
        this.linkedFeature = 'general';

        this.outputs = [
            {
                name: '',
                portId: 'data_available',
                params: [
                    {
                        name: 'data',
                        dataType: TibboDataType.STRING,
                    },
                    {
                        name: 'complete_data',
                        dataType: TibboDataType.STRING,
                    },
                ],
            },
        ];


        const settings: Setting[] = [
            {
                id: 'SERIAL_PORT',
                name: 'Serial Port',
                settingType: SettingType.OPTION,
                capabilityRequirement: 'serial',
                required: true,
                default: '',
            },
            {
                id: 'MODE',
                name: 'Data Mode',
                settingType: SettingType.OPTION,
                required: true,
                default: '0',
                options: [
                    {
                        name: 'Raw Data',
                        value: '0',
                    },
                    {
                        name: 'Packet',
                        value: '1',
                    },
                ],
            },
            {
                id: 'PACKET_START',
                name: 'Packet Start',
                settingType: SettingType.STRING,
                required: true,
                helpText: `This can be a string or a character. 
Use escape characters for special characters. For example, to match the character 'Carriage return', use '\\x0D'.`,
                default: '',
            },
            {
                id: 'PACKET_END',
                name: 'Packet End',
                settingType: SettingType.STRING,
                required: true,
                helpText: `This can be a string or a character. 
Use escape characters for special characters. For example, to match the character 'Carriage return', use '\\x0D'.`,
                default: '',
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getSettingValue(settingId: string): string {
        if (settingId === 'DISPLAY_NAME') {
            const project: ProjectConfiguration = this.project;
            const SERIAL_PORT = project.getFeature(this.getSettingValue('SERIAL_PORT'));
            if (SERIAL_PORT) {
                return `On Serial Data {{$${SERIAL_PORT.getID()}}}`;
            }
        }
        return super.getSettingValue(settingId);
    }

    getState(settingId: string): SettingState {
        const MODE = this.getSettingValue('MODE');
        switch (settingId) {
            case 'PACKET_START':
            case 'PACKET_END':
                return MODE === '1' ? SettingState.ENABLED : SettingState.HIDDEN;
            default:
                return super.getState(settingId);
        }
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'tios':
                return tios.getCodeBlocks(this);
            case 'simulator':
                return simulator.getCodeBlocks(this);
            case 'zephyr':
                return zephyr.getCodeBlocks(this);
            default:
                return [];
        }
    }

    getDetails(): string {
        return `
`;
    }
}
